import ClimaLight from '@crehana/compass.icons.logos/ClimaLight';
import DesempenoLight from '@crehana/compass.icons.logos/DesempenoLight';
import LearningLight from '@crehana/compass.icons.logos/LearningLight';
import Administrate from '@crehana/compass.icons.outline/Administrate';
import AlertCicle from '@crehana/compass.icons.outline/AlertCircle';
import ArrowRandom from '@crehana/compass.icons.outline/ArrowRandom';
import Article from '@crehana/compass.icons.outline/Article';
import Award from '@crehana/compass.icons.outline/Award';
import Badge from '@crehana/compass.icons.outline/Badge';
import BalanceScale from '@crehana/compass.icons.outline/BalanceScale';
import Bell from '@crehana/compass.icons.outline/Bell';
import Book from '@crehana/compass.icons.outline/Book';
import Box from '@crehana/compass.icons.outline/Box';
import BriefCase from '@crehana/compass.icons.outline/Briefcase';
import Bulb from '@crehana/compass.icons.outline/Bulb';
import Camera from '@crehana/compass.icons.outline/Camera';
import Car from '@crehana/compass.icons.outline/Car';
import Certificate from '@crehana/compass.icons.outline/Certificate';
import Chat from '@crehana/compass.icons.outline/Chat';
import ChatPremium from '@crehana/compass.icons.outline/ChatPremium';
import ColorPalette from '@crehana/compass.icons.outline/ColorPalette';
import Congrats from '@crehana/compass.icons.outline/Congrats';
import CreditCard from '@crehana/compass.icons.outline/CreditCard';
import Crown from '@crehana/compass.icons.outline/Crown';
import Diploma from '@crehana/compass.icons.outline/Diploma';
import Edit2 from '@crehana/compass.icons.outline/Edit2';
import Fire from '@crehana/compass.icons.outline/Fire';
import Gift from '@crehana/compass.icons.outline/Gift';
import Globe from '@crehana/compass.icons.outline/Globe';
import Globe2 from '@crehana/compass.icons.outline/Globe2';
import GraduationCap from '@crehana/compass.icons.outline/GraduationCap';
import HeadPhone from '@crehana/compass.icons.outline/Headphones';
import Heart from '@crehana/compass.icons.outline/Heart';
import Home from '@crehana/compass.icons.outline/Home';
import Image from '@crehana/compass.icons.outline/Image';
import Key from '@crehana/compass.icons.outline/Key';
import Leader from '@crehana/compass.icons.outline/Leader';
import Like from '@crehana/compass.icons.outline/Like';
import Lock from '@crehana/compass.icons.outline/Lock';
import MegaPhone from '@crehana/compass.icons.outline/Megaphone';
import Moon from '@crehana/compass.icons.outline/Moon';
import Music from '@crehana/compass.icons.outline/Music';
import PaperPlane from '@crehana/compass.icons.outline/PaperPlane';
import People from '@crehana/compass.icons.outline/People';
import Person from '@crehana/compass.icons.outline/Person';
import PersonDone from '@crehana/compass.icons.outline/PersonDone';
import Ranking from '@crehana/compass.icons.outline/Ranking';
import Rocket from '@crehana/compass.icons.outline/Rocket';
import Schedule from '@crehana/compass.icons.outline/Schedule';
import ShoppingBag from '@crehana/compass.icons.outline/ShoppingBag';
import ShoppingCart from '@crehana/compass.icons.outline/ShoppingCart';
import Star from '@crehana/compass.icons.outline/Star';
import Sun from '@crehana/compass.icons.outline/Sun';
import UserApps from '@crehana/compass.icons.outline/UserApps';
import CrehanaIso from '@crehana/icons/logos/CrehanaIso';
import { jsx as _jsx } from "react/jsx-runtime";
export var IconsFolders = [{
  value: 'person',
  label: /*#__PURE__*/_jsx(Person, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '1'
}, {
  value: 'moon',
  label: /*#__PURE__*/_jsx(Moon, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '2'
}, {
  value: 'people',
  label: /*#__PURE__*/_jsx(People, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '3'
}, {
  value: 'badge',
  label: /*#__PURE__*/_jsx(Badge, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '4'
}, {
  value: 'sun',
  label: /*#__PURE__*/_jsx(Sun, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '5'
}, {
  value: 'car',
  label: /*#__PURE__*/_jsx(Car, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '6'
}, {
  value: 'edit2',
  label: /*#__PURE__*/_jsx(Edit2, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '7'
}, {
  value: 'like',
  label: /*#__PURE__*/_jsx(Like, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '8'
}, {
  value: 'chatPremium',
  label: /*#__PURE__*/_jsx(ChatPremium, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '9'
}, {
  value: 'globe2',
  label: /*#__PURE__*/_jsx(Globe2, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '10'
}, {
  value: 'balanceScale',
  label: /*#__PURE__*/_jsx(BalanceScale, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '11'
}, {
  value: 'alertCircle',
  label: /*#__PURE__*/_jsx(AlertCicle, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '12'
}, {
  value: 'article',
  label: /*#__PURE__*/_jsx(Article, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '13'
}, {
  value: 'home',
  label: /*#__PURE__*/_jsx(Home, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '14'
}, {
  value: 'graduationCap',
  label: /*#__PURE__*/_jsx(GraduationCap, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '15'
}, {
  value: 'paperPlane',
  label: /*#__PURE__*/_jsx(PaperPlane, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '16'
}, {
  value: 'award',
  label: /*#__PURE__*/_jsx(Award, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '17'
}, {
  value: 'userApps',
  label: /*#__PURE__*/_jsx(UserApps, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '18'
}, {
  value: 'crown',
  label: /*#__PURE__*/_jsx(Crown, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '19'
}, {
  value: 'administrate',
  label: /*#__PURE__*/_jsx(Administrate, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '20'
}, {
  value: 'gift',
  label: /*#__PURE__*/_jsx(Gift, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '21'
}, {
  value: 'box',
  label: /*#__PURE__*/_jsx(Box, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '22'
}, {
  value: 'key',
  label: /*#__PURE__*/_jsx(Key, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '23'
}, {
  value: 'leader',
  label: /*#__PURE__*/_jsx(Leader, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '24'
}, {
  value: 'image',
  label: /*#__PURE__*/_jsx(Image, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '25'
}, {
  value: 'chat',
  label: /*#__PURE__*/_jsx(Chat, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '26'
}, {
  value: 'camera',
  label: /*#__PURE__*/_jsx(Camera, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '27'
}, {
  value: 'creditCard',
  label: /*#__PURE__*/_jsx(CreditCard, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '28'
}, {
  value: 'headPhone',
  label: /*#__PURE__*/_jsx(HeadPhone, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '29'
}, {
  value: 'book',
  label: /*#__PURE__*/_jsx(Book, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '30'
}, {
  value: 'heart',
  label: /*#__PURE__*/_jsx(Heart, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '31'
}, {
  value: 'bell',
  label: /*#__PURE__*/_jsx(Bell, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '32'
}, {
  value: 'bulb',
  label: /*#__PURE__*/_jsx(Bulb, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '33'
}, {
  value: 'lock',
  label: /*#__PURE__*/_jsx(Lock, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '34'
}, {
  value: 'music',
  label: /*#__PURE__*/_jsx(Music, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '35'
}, {
  value: 'glove',
  label: /*#__PURE__*/_jsx(Globe, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '36'
}, {
  value: 'ranking',
  label: /*#__PURE__*/_jsx(Ranking, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '37'
}, {
  value: 'schedule',
  label: /*#__PURE__*/_jsx(Schedule, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '38'
}, {
  value: 'colorPalette',
  label: /*#__PURE__*/_jsx(ColorPalette, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '39'
}, {
  value: 'star',
  label: /*#__PURE__*/_jsx(Star, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '40'
}, {
  value: 'certificate',
  label: /*#__PURE__*/_jsx(Certificate, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '41'
}, {
  value: 'congrats',
  label: /*#__PURE__*/_jsx(Congrats, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '42'
}, {
  value: 'diploma',
  label: /*#__PURE__*/_jsx(Diploma, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '43'
}, {
  value: 'briefcase',
  label: /*#__PURE__*/_jsx(BriefCase, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '44'
}, {
  value: 'personDone',
  label: /*#__PURE__*/_jsx(PersonDone, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '45'
}, {
  value: 'rocket',
  label: /*#__PURE__*/_jsx(Rocket, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '46'
}, {
  value: 'shoppingBag',
  label: /*#__PURE__*/_jsx(ShoppingBag, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '47'
}, {
  value: 'shoppingCart',
  label: /*#__PURE__*/_jsx(ShoppingCart, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '48'
}, {
  value: 'megaphone',
  label: /*#__PURE__*/_jsx(MegaPhone, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '49'
}, {
  value: 'crehana',
  label: /*#__PURE__*/_jsx(CrehanaIso, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '50'
}, {
  value: 'clima',
  label: /*#__PURE__*/_jsx(ClimaLight, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '51'
}, {
  value: 'desempeno',
  label: /*#__PURE__*/_jsx(DesempenoLight, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '52'
}, {
  value: 'learning',
  label: /*#__PURE__*/_jsx(LearningLight, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '53'
}, {
  value: 'fire',
  label: /*#__PURE__*/_jsx(Fire, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '54'
}, {
  value: 'arrowRandom',
  label: /*#__PURE__*/_jsx(ArrowRandom, {
    className: "tw-fill-current",
    size: 18
  }),
  id: '55'
}];